"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

const RudderStack = ({ children }: { children: React.ReactNode }) => {
	const pathname = usePathname();

	useEffect(() => {
		window.rudderanalytics?.page();
	}, [pathname]);

	return <>{children}</>;
};

export default RudderStack;
